import request from '@/utils/request'

// 静态代理相关接口
export function getProxyList(params) {
  return getStaticProxyList(params)
}

export function purchaseProxy(data) {
  return request({
    url: '/api/proxy/static/purchase',
    method: 'post',
    data,
    mock: true
  })
}

export function renewProxy(data) {
  return request({
    url: '/ums/user-ip/renew',
    method: 'post',
    data
  })
}

// 余额支付接口
export function balancePay(data) {
  return request({
    url: '/oms/order/balance-pay',
    method: 'post',
    data
  })
}

export function getRenewalRecords(params) {
  return request({
    url: '/api/proxy/static/renewal/records',
    method: 'get',
    params
  })
}

export function changeProxyIP(id) {
  return request({
    url: '/api/proxy/static/change',
    method: 'post',
    data: { id }
  })
}

export function batchChangeProxyIP(ids) {
  return request({
    url: '/api/proxy/static/change/batch',
    method: 'post',
    data: { ids }
  })
}

export function refundProxy(id) {
  return request({
    url: '/api/proxy/static/refund',
    method: 'post',
    data: { id }
  })
}

// 静态住宅代理相关接口
export function getStaticProxyList(params) {
  // 移除空字符串参数
  const cleanParams = Object.entries(params || {}).reduce((acc, [key, value]) => {
    if (value !== undefined && value !== '' && value !== null) {
      acc[key] = value
    }
    return acc
  }, {})
  
  // 添加固定的proxyType参数
  cleanParams.proxyType = 'staticResidential'

  return request({
    url: '/ums/user-ip',
    method: 'get',
    params: cleanParams,
    mock: false
  })
}

export function getStaticProxyRenewalList(params) {
  const cleanParams = Object.entries(params || {}).reduce((acc, [key, value]) => {
    if (value !== undefined && value !== '' && value !== null) {
      acc[key] = value
    }
    return acc
  }, {})

  return request({
    url: '/ums/user-ip/renew-list',
    method: 'get',
    params: cleanParams,
    mock: false
  })
}

export function exportStaticProxyList(params) {
  const cleanParams = Object.entries(params || {}).reduce((acc, [key, value]) => {
    if (value !== undefined && value !== '' && value !== null) {
      acc[key] = value
    }
    return acc
  }, {})

  return request({
    url: '/ums/user-ip/export',
    method: 'get',
    params: cleanParams
  })
}

export function purchaseStaticProxy(data) {
  return request({
    url: '/api/proxy/static/residential/purchase',
    method: 'post',
    data,
    mock: true
  })
}

// export function renewStaticProxy(data) {
//   return request({
//     url: '/api/proxy/static/residential/renew',
//     method: 'post',
//     data,
//     mock: true
//   })
// }

// 获取国家列表
export function getCountryList(params) {
  return request({
    url: '/cms/country',
    method: 'get',
    params
  })
}

// 批量复制代理信息
export function batchCopyProxyInfo(ids) {
  return request({
    url: '/ums/user-ip/batch-copy-proxy-info',
    method: 'get',
    params: { ids }
  })
}

// 获取IP状态统计信息
export function getIpStatCount(proxyType = 'staticResidential') {
  return request({
    url: '/ums/user-ip/stat-count',
    method: 'get',
    params: { proxyType }
  })
}

// 获取代理套餐列表
export function getProxyPackageList(params) {
  return request({
    url: '/pms/product/proxy-package',
    method: 'get',
    params,
    headers: {
      'lang': 'zh_cn' // 默认简体中文
    }
  })
}

// 获取产品地区列表
export function getProductCountryList(params) {
  return request({
    url: '/cms/country/product-country',
    method: 'get',
    params
  })
}

// 计算订单价格（代理商管理员专用）
export function calculateOrderPrice(data, skipGlobalErrorHandler = false) {
  return request({
    url: '/open/calculate-price',
    method: 'post',
    data,
    skipGlobalErrorHandler
  })
}

// 代理商普通用户计算价格接口
export function calculateResellerPrice(data, skipGlobalErrorHandler = false) {
  return request({
    url: '/oms/order/calculate-price',
    method: 'post',
    data,
    skipGlobalErrorHandler
  })
}

// 批量修改标签接口
export function batchUpdateTag(data) {
  return request({
    url: '/ums/user-ip/batch-update-tag',
    method: 'post',
    data
  })
}
